import { render, staticRenderFns } from "./ColumnTitle.vue?vue&type=template&id=4072b754&scoped=true&"
import script from "./ColumnTitle.vue?vue&type=script&lang=js&"
export * from "./ColumnTitle.vue?vue&type=script&lang=js&"
import style0 from "./ColumnTitle.vue?vue&type=style&index=0&id=4072b754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072b754",
  null
  
)

export default component.exports